import {
  ADDPRODUCTTOSTOCK,
  ADDPRODUCTSTOSTOCK,
  HANDLESTOCKITEMQUENTITY,
} from "./actionType";
import initalState from "./initialState";

// the function will return a value that will be our new Product id ...
const nextProductId = (products) => {
  if (products?.length === 0) {
    return 1;
  } else {
    let nextId = products?.reduce((maxId, product) => {
      return Math.max(maxId, product?.id);
    }, -1);
    return nextId + 1;
  }
};

const productItemsReducer = (state = initalState, action) => {
  switch (action.type) {
    case ADDPRODUCTTOSTOCK:
      return [...state, { ...action.payload, id: `${nextProductId(state)}` }];

    case ADDPRODUCTSTOSTOCK:
      return state.map((product) => {
        if (product?.id === action.payload?.id) {
          return {
            ...product,
            quantity:
              Number(product.quantity) + action.payload?.itemQuantityToAdd,
          };
        }
        return product;
      });

    case HANDLESTOCKITEMQUENTITY:
      const { id, oparationType } = action.payload;

      switch (oparationType) {
        case "plus":
          return state.map((product) => {
            if (product?.id === id) {
              return {
                ...product,
                quantity: Number(product?.quantity) + 1,
              };
            }
            return product;
          });

        case "minus":
          return state.map((product) => {
            if (product?.id === id) {
              return {
                ...product,
                quantity: Number(product?.quantity) - 1,
              };
            }
            return product;
          });

        default:
          return state;
      }

    default:
      return state;
  }
};

export default productItemsReducer;
